import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { LaborService } from '../labor.service';
import { PartInfoComponent } from '../part-info/part-info.component';
import { DataService } from '../data.service';

@Component({
  selector: 'alldata',
  templateUrl: './alldata.component.html',
  styleUrls: ['./alldata.component.css']
})
export class AlldataComponent implements OnInit {
  @Input() vinNumber: string;
  @Input() laborName: string;
  selectedParts = [];
  @Output() saveAllData: EventEmitter<string> = new EventEmitter<string>();
  @Output() loadAppData: EventEmitter<any> = new EventEmitter<any>();

  categories = [];
  labors = [];
  parts = [];
  menus = [];
  isLoading = false;
  laborType = 'navigation';
  allDataPath = '';
  currentVehicle = {};

  constructor(
    private laborService: LaborService,
    private dataShareService: DataService
  ) { }

  ngOnInit() {
    this.loadCategories();
    this.menus.push({
      'Name': 'HOME',
      'Value': 'home'
    })
  }

  loadCategories(): void {
    this.laborService.getAllDataCategories(this.vinNumber)
      .subscribe(data => {
        let vehicleInfo = data['vehicleInfo'];

        this.laborService.getAppDataByVehicle(vehicleInfo, this.laborName)
          .subscribe(data => {            
            this.loadAppData.emit(data['AppData']);
            // this.dataShareService.sendDataToOtherComponent(data['AppData']['PartNumbers']);
          });

        this.dataShareService.saveVehicleInfo(vehicleInfo);

        // get vehicle infomation and save into dynamodb
        // this.laborService.saveVehicle(vehicleInfo, this.laborName)
        //   .subscribe(data => {
        //     console.log(data);
        //     this.currentVehicle = data['vehicle']['vehicle'];
        //     if (data['appData'].hasOwnProperty('AllDataPath')) {
        //       this.loadAppData.emit(data['appData']);
        //     }

        //     this.dataShareService.saveVehicleId(this.currentVehicle['VehicleId']);
        //   });

        this.labors = data['labors'];
        this.isLoading = false;
      });
  }

  onSaveSelectedPart(partNumber): void {
    let partNumberIndex = this.selectedParts.indexOf(partNumber);
    if (partNumber < 0) {
      this.selectedParts.push(partNumber);
    } else {
      this.selectedParts.splice(partNumberIndex, 1);
    }
    console.log(this.selectedParts);
  }

  onSaveDataPath(laborName): void {
    var pathIndex = this.allDataPath.indexOf('||');
    if (pathIndex > 0) {
      this.allDataPath = this.allDataPath.substring(0, pathIndex);
    }

    var startIndex = this.allDataPath.indexOf('supplier_id');
    var endIndex = this.allDataPath.indexOf('components');
    this.allDataPath = this.allDataPath.substring(0, startIndex) + 'supplier_id/carId/' + this.allDataPath.substring(endIndex) + '||' + laborName;
    this.saveAllData.emit(this.allDataPath);
  }

  goTo(menu): void {
    this.isLoading = true;
    if (menu.Value == 'home') {
      this.loadCategories();
      this.menus.splice(1);
      this.laborType = 'navigation';
    } else {
      this.laborService.getAllDataDetail(this.vinNumber, menu.Value)
        .subscribe(data => {
          this.labors = data['labors'];
          var menuIndex = this.menus.indexOf(menu);
          this.menus.splice(menuIndex + 1);
          this.isLoading = false;
          this.laborType = data['type'];
        });
    }
  }

  getDetail(category): void {
    this.isLoading = true;
    this.menus.push({
      'Name': category['Name'],
      'Value': category['Value'],
    });
    this.allDataPath = category.Value;
    
    this.laborService.getAllDataDetail(this.vinNumber, category.Value)
      .subscribe(data => {
        this.labors = data['labors'];
        if (this.labors == undefined) {
          this.labors = [];
        }
        this.laborType = data['type'];
        console.log(data);
        // if (category.Value.includes('data')) {
        if (data['parts'] != undefined) {
          this.parts = data['parts'];
        }
        this.isLoading = false;
      })     
  }
}
